import React from "react";

import "../../assets/css/loader.css";

const LoadingSpinner = () => (
  <div className="d-flex justify-content-center">
    <div className="loader">{/* <i className="loader" /> Loading... */}</div>
  </div>
  
  // <div className="cover-spin"> </div>
);
// var sectionStyle = {
//   width: "100%",
//   height: "400px",
//   //  backgroundImage: { img }
// };
export default LoadingSpinner;
